/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "checkmark",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#FFFFFF"
            },
            "checkmark": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "12.6",
            "height": "10.1"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12.6 10.1", className: "checkmark", width: this.props.width, height: this.props.height, style: this.props.checkmark },
            _react2["default"].createElement("path", { className: "st0", d: "M12.2.2c-.4-.4-1-.3-1.4.1L4.4 7.6 1.7 4.9c-.4-.4-1-.4-1.4 0s-.4 1 0 1.4l3.5 3.5.2.2s.1 0 .1.1c.1 0 .2.1.4.1.1 0 .3 0 .4-.1 0-.1 0-.1.1-.1s.1-.1.2-.1l7.1-8.1c.4-.6.4-1.2-.1-1.6z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/checkmark.js